import {Routes, Route} from 'external/react' 
import HomeworksPage from './HomeworksPage'
import Homework from './Homework'

export default function HomeworksRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomeworksPage />} />
      <Route path="/:homeworkId/*" element={<Homework />} />
    </Routes>
  )
}
